import React from "react";
import classNames from "classnames";

import "./resizable-panel.scss";

interface IProps {
  collapsed: boolean;
  id?: string;
  headingLabel?: string;
  headingExtra?: React.ReactNode;
  tabIndex?: number;
}

// Originally this monitored the collapse animation and stopped rendering
// the children when the animation was finished. And then started rendering
// the children again when collapsed was false and then expanded.
//
// This added a lot of complexity and resulted in slower animations.
// The downside is that now developers can't disable all of the extra
// documents shown on the left sided just by collapsing it.
// There is now a hotkey cmd-shit-f which makes the right side take
// the full width and does not render the left side at all.
export const ResizablePanel: React.FC<IProps> = ({collapsed, id, headingLabel, headingExtra, tabIndex, children }) => {
  const headingId = id ? `${id}-heading` : undefined;
  const hasHeading = !!(id && headingLabel);

  return (
    <section
      className={classNames("resizable-panel", {collapsed})}
      aria-labelledby={hasHeading ? headingId : undefined}
      id={id}
      tabIndex={tabIndex}
    >
      {hasHeading && (
        <div className={classNames("section-heading-row", id)}>
          <h2 id={headingId} className={classNames("section-heading", id)}>
            {headingLabel}
          </h2>
          {headingExtra}
        </div>
      )}
      {children}
    </section>
  );
};
